import api from './api';
import { hasPlanFeature, setPlan } from './auth';

// O plano fica no localStorage desde o login: uma feature incluída no plano
// depois só apareceria num novo login. Antes de bloquear, reconfere no backend.
export const confirmPlanFeature = async featureValue => {
    if (hasPlanFeature(featureValue)) return true;

    try {
        const { data } = await api.get('/plan');
        setPlan(data.plan);
    } catch (error) {
        return false;
    }

    return hasPlanFeature(featureValue);
};
